import ScheduledGoalList from '../goals/scheduled-goal-list';

export default function YEAR_CURRENTYEARGOALS({ currentYearGoals, refreshGoals }) {
  return <div className="goals">{currentYearGoals?.length
    ? <ScheduledGoalList goals={currentYearGoals} refreshGoals={refreshGoals} />
    : <p>No yearly goals yet. Quarterly goals appear alongside this list.</p>}
  </div>;
}
